export interface TimeSlot {
  id: string;
  subject: string;
  time: string;
  location?: string;
  staff?: string;
  day: string;
  color?: string;
  notifications?: {
    beforeStart: boolean;
    beforeEnd: boolean;
  };
}

export interface TimetableData {
  [key: string]: TimeSlot[];
}

export const SUBJECT_COLORS = [
  '#FF6B6B',  // Red
  '#4ECDC4',  // Teal
  '#45B7D1',  // Blue
  '#96CEB4',  // Green
  '#FFEEAD',  // Yellow
  '#D4A5A5',  // Pink
  '#9A77CF',  // Purple
  '#F3A953',  // Orange
  '#A8E6CF',  // Mint
  '#FF9AA2',  // Coral
];
